var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.0563 8.94447C44.4639 2.35184 33.737 2.35184 27.1446 8.94447C22.8113 13.2777 21.2371 19.5215 22.7705 25.2746L4.49633 43.5487C4.17925 43.8658 4.00101 44.2958 4.00101 44.7442V54.3091C4.00101 55.2429 4.75805 55.9999 5.69182 55.9999H15.2567C15.7051 55.9999 16.1351 55.8217 16.4522 55.5046L18.8434 53.1134C19.1604 52.7963 19.3386 52.3663 19.3386 51.9179V48.8263H22.4301C22.8785 48.8263 23.3085 48.6482 23.6256 48.3311L26.0169 45.9398C26.334 45.6228 26.5121 45.1927 26.5121 44.7443V41.6528H29.6037C30.0521 41.6528 30.4821 41.4745 30.7992 41.1575L34.726 37.2306C40.4797 38.7642 46.7229 37.1897 51.0561 32.8565C57.649 26.2641 57.649 15.5372 51.0563 8.94447ZM48.6655 30.4653C45.0137 34.117 39.6938 35.3634 34.7817 33.7179C34.1735 33.5141 33.5025 33.672 33.049 34.1255L28.9036 38.2708H24.8216C23.8879 38.2708 23.1308 39.0279 23.1308 39.9617V44.0437L21.73 45.4445H17.648C16.7142 45.4445 15.9571 46.2016 15.9571 47.1353V51.2173L14.5565 52.6182H7.38273V45.4446L25.8753 26.952C26.3288 26.4985 26.4867 25.8275 26.283 25.2194C24.6376 20.3072 25.884 14.9873 29.5356 11.3356C34.8098 6.06162 43.3912 6.06152 48.6655 11.3356C53.9394 16.6097 53.9394 25.1913 48.6655 30.4653Z",
    fill: "#156981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2732 13.7269C43.6362 11.0898 39.3454 11.0898 36.7084 13.7269C34.0713 16.364 34.0713 20.6546 36.7084 23.2918C39.3454 25.9289 43.6361 25.929 46.2732 23.2918C48.9103 20.6548 48.9103 16.3641 46.2732 13.7269ZM43.8821 20.9005C42.5636 22.2189 40.4182 22.2189 39.0996 20.9005C37.7811 19.582 37.7811 17.4366 39.0996 16.118C40.4181 14.7997 42.5635 14.7995 43.8821 16.118C45.2005 17.4366 45.2005 19.582 43.8821 20.9005Z",
    fill: "#156981"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.0b9515af88f48175fd83fb8f8f3380c9.svg";
export { ForwardRef as ReactComponent };